/* istanbul ignore file */

export const NEXT_PHOTO = 'Next photo';
export const PHOTOS_LABEL = 'Customer photos';
export const PREVIOUS_PHOTO = 'Previous photo';
/* The reply's own heading, which replaces the preview card's "Read <partner name>'s
   reply" call to action: on the full review the reply is already there to read, so the
   row says who wrote it rather than inviting a click. */
export const REPLIED_SUFFIX = 'replied';
/* What the footer says when the review has no reviewer detail for that half. Trust
   signalling rather than identity, which is why it survives as the fallback: a review
   with no name still needs to say something about who left it. The two halves fall back
   independently, so a review with a name and no location reads "Marina  Verified". */
export const REVIEWER_NAME_FALLBACK = 'Trusted Reviewer';
export const REVIEWER_LOCATION_FALLBACK = 'Verified';
